import React from 'react'
import { Outlet } from 'react-router-dom'

const PublicRoutesLayout = ({ children }) => {
  return (
    <>
      <Outlet />
    </>
  )
}

export default PublicRoutesLayout;